import { ApiResult, HttpClient } from "../http.js";

/**
 * Mirrors the .NET `TermsTemplateDto`
 * (Mesterplan.Features.Settings.Terms.TermsTemplateDto).
 */
export interface TermsTemplateDto {
  id: string;
  name: string;
  /** Rich-text (HTML) body of the terms & conditions template. */
  content: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTermsTemplatePayload {
  name: string;
  content: string;
  isDefault: boolean;
}

export interface UpdateTermsTemplatePayload {
  name: string;
  content: string;
}

/**
 * Company-scoped terms & conditions templates, served by the .NET API
 * (`/api/settings/terms-templates`). Replaces the legacy Firestore
 * `COMPANIES/{companyId}/termsTemplates` subcollection.
 */
export class TermsTemplatesApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<TermsTemplateDto[]>> {
    return this.http.get<TermsTemplateDto[]>("/api/settings/terms-templates");
  }

  /** Returns the new template's id. */
  create(payload: CreateTermsTemplatePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/settings/terms-templates", {
      body: payload,
    });
  }

  update(
    id: string,
    payload: UpdateTermsTemplatePayload,
  ): Promise<ApiResult<void>> {
    return this.http.put<void>(
      `/api/settings/terms-templates/${encodeURIComponent(id)}`,
      { body: payload },
    );
  }

  delete(id: string): Promise<ApiResult<void>> {
    return this.http.delete<void>(
      `/api/settings/terms-templates/${encodeURIComponent(id)}`,
    );
  }

  /** Marks the given template as the company default, unsetting any other. */
  setDefault(id: string): Promise<ApiResult<void>> {
    return this.http.post<void>(
      `/api/settings/terms-templates/${encodeURIComponent(id)}/set-default`,
    );
  }
}
